import { useEffect, useState } from 'react'
import Layout from './Layout'
import { listarModelos, criarModelo, atualizarModelo, deletarModelo } from '../services/api'

const tipos = [
  { value:'despacho', label:'Despacho / informação' },
  { value:'tramitacao', label:'Encaminhamento' },
  { value:'pendencia', label:'Solicitação de documentos' },
  { value:'conclusao', label:'Conclusão' },
]

export default function Modelos() {
  const [lista, setLista] = useState([])
  const [form, setForm] = useState({ nome:'', atalho:'', conteudo:'', tipo:'despacho' })
  const [editando, setEditando] = useState(null)
  const [erro, setErro] = useState('')
  const [sucesso, setSucesso] = useState('')

  useEffect(() => { carregar() }, [])
  async function carregar() {
    try { const r = await listarModelos(); setLista(r.data) } catch {}
  }

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }))

  async function salvar() {
    if (!form.nome || !form.conteudo) { setErro('Nome e conteúdo são obrigatórios'); return }
    setErro('')
    try {
      if (editando) { await atualizarModelo(editando, form); setSucesso('Modelo atualizado!') }
      else { await criarModelo(form); setSucesso('Modelo criado!') }
      setForm({ nome:'', atalho:'', conteudo:'', tipo:'despacho' }); setEditando(null)
      carregar(); setTimeout(() => setSucesso(''), 3000)
    } catch (e) { setErro(e.response?.data?.erro || 'Erro ao salvar') }
  }

  function editar(m) {
    setEditando(m.id)
    setForm({ nome:m.nome, atalho:m.atalho||'', conteudo:m.conteudo, tipo:m.tipo })
  }

  return (
    <Layout>
      <h1 style={{ fontSize:18, fontWeight:500, margin:'0 0 24px' }}>Modelos de texto padrão</h1>
      <div style={{ display:'grid', gridTemplateColumns:'380px 1fr', gap:20 }}>
        <div style={{ background:'white', borderRadius:12, border:'1px solid #e5e7eb', padding:20 }}>
          <div style={{ fontSize:14, fontWeight:500, marginBottom:16 }}>{editando ? 'Editar modelo' : 'Novo modelo'}</div>

          {[['nome','Nome *','Ex: Deferimento padrão'],['atalho','Atalho','/deferido (opcional)']].map(([k,l,p]) => (
            <div key={k} style={{ marginBottom:12 }}>
              <label style={{ display:'block', fontSize:12, fontWeight:500, marginBottom:4, color:'#374151' }}>{l}</label>
              <input value={form[k]} onChange={e=>set(k,e.target.value)} placeholder={p}
                style={{ width:'100%', padding:'8px 10px', border:'1px solid #d1d5db', borderRadius:8, fontSize:13, boxSizing:'border-box' }} />
            </div>
          ))}

          <div style={{ marginBottom:12 }}>
            <label style={{ display:'block', fontSize:12, fontWeight:500, marginBottom:4, color:'#374151' }}>Tipo</label>
            <select value={form.tipo} onChange={e=>set('tipo',e.target.value)}
              style={{ width:'100%', padding:'8px 10px', border:'1px solid #d1d5db', borderRadius:8, fontSize:13 }}>
              {tipos.map(t => <option key={t.value} value={t.value}>{t.label}</option>)}
            </select>
          </div>

          <div style={{ marginBottom:14 }}>
            <label style={{ display:'block', fontSize:12, fontWeight:500, marginBottom:4, color:'#374151' }}>Conteúdo do texto *</label>
            <textarea value={form.conteudo} onChange={e=>set('conteudo',e.target.value)}
              placeholder="Texto padrão que será inserido automaticamente..."
              style={{ width:'100%', padding:'8px 10px', border:'1px solid #d1d5db', borderRadius:8, fontSize:13, minHeight:100, resize:'vertical', boxSizing:'border-box' }} />
            <div style={{ fontSize:11, color:'#9ca3af', marginTop:3 }}>
              Variáveis disponíveis: {'{{numero}}'}, {'{{requerente}}'}, {'{{data}}'}
            </div>
          </div>

          {erro && <div style={{ background:'#fef2f2', border:'1px solid #fecaca', borderRadius:8, padding:10, fontSize:12, color:'#dc2626', marginBottom:10 }}>{erro}</div>}
          {sucesso && <div style={{ background:'#f0fdf4', border:'1px solid #bbf7d0', borderRadius:8, padding:10, fontSize:12, color:'#15803d', marginBottom:10 }}>{sucesso}</div>}

          <div style={{ display:'flex', gap:8 }}>
            <button onClick={salvar} style={{ flex:1, padding:9, background:'#185FA5', color:'white', border:'none', borderRadius:8, fontSize:13, cursor:'pointer' }}>
              {editando ? 'Salvar' : 'Criar modelo'}
            </button>
            {editando && <button onClick={() => { setEditando(null); setForm({ nome:'', atalho:'', conteudo:'', tipo:'despacho' }) }}
              style={{ padding:'9px 12px', border:'1px solid #d1d5db', borderRadius:8, fontSize:13, cursor:'pointer', background:'white' }}>✕</button>}
          </div>
        </div>

        <div style={{ background:'white', borderRadius:12, border:'1px solid #e5e7eb', overflow:'hidden' }}>
          <div style={{ padding:'14px 20px', borderBottom:'1px solid #f3f4f6', fontSize:14, fontWeight:500 }}>
            {lista.length} modelo{lista.length !== 1 ? 's' : ''} cadastrado{lista.length !== 1 ? 's' : ''}
          </div>
          {lista.length === 0
            ? <div style={{ padding:32, textAlign:'center', color:'#9ca3af', fontSize:14 }}>Nenhum modelo cadastrado.</div>
            : lista.map((m,i) => (
              <div key={m.id} style={{ padding:'14px 20px', borderBottom:i<lista.length-1?'1px solid #f3f4f6':'none' }}>
                <div style={{ display:'flex', alignItems:'flex-start', gap:10 }}>
                  <div style={{ flex:1 }}>
                    <div style={{ display:'flex', alignItems:'center', gap:8, marginBottom:4 }}>
                      <div style={{ fontSize:13, fontWeight:500 }}>{m.nome}</div>
                      {m.atalho && <code style={{ background:'#f3f4f6', padding:'1px 6px', borderRadius:4, fontSize:11, color:'#185FA5' }}>{m.atalho}</code>}
                      <span style={{ background:'#E6F1FB', color:'#185FA5', fontSize:10, padding:'1px 6px', borderRadius:99 }}>
                        {tipos.find(t=>t.value===m.tipo)?.label||m.tipo}
                      </span>
                    </div>
                    <div style={{ fontSize:12, color:'#6b7280', lineHeight:1.5, maxHeight:40, overflow:'hidden' }}>{m.conteudo}</div>
                  </div>
                  <div style={{ display:'flex', gap:6, flexShrink:0 }}>
                    <button onClick={() => editar(m)} style={{ padding:'5px 10px', border:'1px solid #d1d5db', borderRadius:6, fontSize:12, cursor:'pointer', background:'white' }}>Editar</button>
                    <button onClick={async () => { if(window.confirm('Remover?')) { await deletarModelo(m.id); carregar() } }}
                      style={{ padding:'5px 10px', border:'1px solid #fecaca', borderRadius:6, fontSize:12, cursor:'pointer', background:'white', color:'#dc2626' }}>Remover</button>
                  </div>
                </div>
              </div>
            ))
          }
        </div>
      </div>
    </Layout>
  )
}
